import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=fc79e4d4&scoped=true&lang=html"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=fc79e4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc79e4d4",
  null
  
)

export default component.exports